// +----------------------------------------------------------------------
// | CRMEB [ CRMEB赋能开发者，助力企业发展 ]
// +----------------------------------------------------------------------
// | Copyright (c) 2016~2024 https://www.crmeb.com All rights reserved.
// +----------------------------------------------------------------------
// | Licensed CRMEB并不是自由软件，未经许可不能去掉CRMEB相关版权
// +----------------------------------------------------------------------
// | Author: CRMEB Team <admin@crmeb.com>
// +----------------------------------------------------------------------

import Layout from '@/layout';
var workRouter = {
  path: '/work',
  component: Layout,
  redirect: '/work/recruit',
  name: 'Work',
  meta: {
    title: '用户',
    icon: 'clipboard'
  },
  children: [{
    path: 'recruit',
    component: function component() {
      return import('@/views/work/post/index');
    },
    name: 'recruitList',
    meta: {
      title: '招聘',
      icon: ''
    }
  }, {
    path: 'jobWanted',
    component: function component() {
      return import('@/views/work/jobWanted/list');
    },
    name: 'jobWantedList',
    meta: {
      title: '求职',
      icon: ''
    }
  }, {
    path: 'postCategory',
    component: function component() {
      return import('@/views/work/postCategory/index');
    },
    name: 'postCategoryList',
    meta: {
      title: '岗位分类',
      icon: ''
    }
  }, {
    path: 'company',
    component: function component() {
      return import('@/views/work/company/list');
    },
    name: 'companyList',
    meta: {
      title: '企业认证信息列表',
      icon: ''
    }
  }, {
    path: 'company/apply',
    component: function component() {
      return import('@/views/work/company/apply');
    },
    name: 'applyList',
    meta: {
      title: '企业认证申请记录',
      icon: ''
    }
  }]
};
export default workRouter;